import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/home/forge/bema.farbcode.net/releases/75292866/client/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/forge/bema.farbcode.net/releases/75292866/client/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/home/forge/bema.farbcode.net/releases/75292866/client/layouts/empty.vue").then(m => m.default || m))
}